import React from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { Container, Row, Col } from "react-bootstrap"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"

const PartnerCarousel = props => {
  var slick_slider = {
    dots: false,
    arrow: false,
    autoplay: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  const data = useStaticQuery(graphql`
    query getLogos2 {
      Dell: file(relativePath: { eq: "Logos/Dell.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      HewlettPackard: file(relativePath: { eq: "Logos/HP.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Lenovo: file(relativePath: { eq: "Logos/Lenovo.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Acer: file(relativePath: { eq: "Logos/Acer.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Asus: file(relativePath: { eq: "Logos/Asus.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Fujitsu: file(relativePath: { eq: "Logos/Fujitsu.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Toshiba: file(relativePath: { eq: "Logos/Toshiba.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Microsoft: file(relativePath: { eq: "Logos/Microsoft.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Samsung: file(relativePath: { eq: "Logos/Samsung.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Google2: file(relativePath: { eq: "Logos/Google.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Lapsafe: file(relativePath: { eq: "Logos/Lapsafe.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Apple: file(relativePath: { eq: "Logos/Apple.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Apple2: file(relativePath: { eq: "Logos/Apple.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Panasonic: file(relativePath: { eq: "Logos/Panasonic.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Sony: file(relativePath: { eq: "Logos/Sony.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Adobe: file(relativePath: { eq: "Logos/Adobe.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Compucharge: file(relativePath: { eq: "Logos/Compucharge.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Lapcabby: file(relativePath: { eq: "Logos/Lapcabby.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Zioxi: file(relativePath: { eq: "Logos/Zioxi.jpg" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Powergistics: file(relativePath: { eq: "Logos/Powergistics.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Kensington: file(relativePath: { eq: "Logos/Kensington.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Ergotron: file(relativePath: { eq: "Logos/Ergotron.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Loxit: file(relativePath: { eq: "Logos/Loxit.jpg" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Aruba: file(relativePath: { eq: "Logos/Aruba.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Cisco: file(relativePath: { eq: "Logos/Cisco.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      DLink: file(relativePath: { eq: "Logos/DLink.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      HP_enterprise: file(relativePath: { eq: "Logos/HP_enterprise.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Netgear: file(relativePath: { eq: "Logos/Netgear.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      TPLink: file(relativePath: { eq: "Logos/TPLink.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Ubiquiti: file(relativePath: { eq: "Logos/Ubiquiti.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Intel: file(relativePath: { eq: "Logos/Intel.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Symantec: file(relativePath: { eq: "Logos/Symantec.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      VMWare: file(relativePath: { eq: "Logos/VMWare.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Sophos: file(relativePath: { eq: "Logos/Sophos.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Watchguard: file(relativePath: { eq: "Logos/Watchguard.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Kaspersky: file(relativePath: { eq: "Logos/Kaspersky.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Seagate: file(relativePath: { eq: "Logos/Seagate.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      WesternDigital: file(relativePath: { eq: "Logos/WesternDigital.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      BenQ: file(relativePath: { eq: "Logos/BenQ.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      BTech: file(relativePath: { eq: "Logos/BTech.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Canon: file(relativePath: { eq: "Logos/Canon.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Casio: file(relativePath: { eq: "Logos/Casio.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Clevertouch: file(relativePath: { eq: "Logos/Clevertouch.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      CTouch: file(relativePath: { eq: "Logos/CTouch.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Epson: file(relativePath: { eq: "Logos/Epson.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Iiyama: file(relativePath: { eq: "Logos/Iiyama.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      LG: file(relativePath: { eq: "Logos/LG.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      NEC: file(relativePath: { eq: "Logos/NEC.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Philips: file(relativePath: { eq: "Logos/Philips.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Promethean: file(relativePath: { eq: "Logos/Promethean.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Sharp: file(relativePath: { eq: "Logos/Sharp.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      Sony: file(relativePath: { eq: "Logos/Sony.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
      ViewSonic: file(relativePath: { eq: "Logos/ViewSonic.png" }) {
        childImageSharp {
          fixed(width: 136) {
            src
            base64
            aspectRatio
            srcSet
            height
            width
          }
        }
      }
    }
  `)

  const educationPartners = [
    { name: "Dell", filename: data.Dell.childImageSharp.fixed },
    { name: "HP", filename: data.HewlettPackard.childImageSharp.fixed },
    { name: "Lenovo", filename: data.Lenovo.childImageSharp.fixed },
    { name: "Acer", filename: data.Acer.childImageSharp.fixed },
    { name: "Asus", filename: data.Asus.childImageSharp.fixed },
    { name: "Fujitsu", filename: data.Fujitsu.childImageSharp.fixed },
    { name: "Toshiba", filename: data.Toshiba.childImageSharp.fixed },
    { name: "Microsoft", filename: data.Microsoft.childImageSharp.fixed },
    { name: "Samsung", filename: data.Samsung.childImageSharp.fixed },
    { name: "Google", filename: data.Google2.childImageSharp.fixed },
    { name: "Lapsafe", filename: data.Lapsafe.childImageSharp.fixed },
    { name: "Apple", filename: data.Apple2.childImageSharp.fixed },
    { name: "Panasonic", filename: data.Panasonic.childImageSharp.fixed },
    { name: "Sony", filename: data.Sony.childImageSharp.fixed },
    { name: "Adobe", filename: data.Adobe.childImageSharp.fixed },
    { name: "Compucharge", filename: data.Compucharge.childImageSharp.fixed },
    { name: "Lapcabby", filename: data.Lapcabby.childImageSharp.fixed },
    { name: "Zioxi", filename: data.Zioxi.childImageSharp.fixed },
    { name: "Powergistics", filename: data.Powergistics.childImageSharp.fixed },
    { name: "Kensington", filename: data.Kensington.childImageSharp.fixed },
    { name: "Ergotron", filename: data.Ergotron.childImageSharp.fixed },
    { name: "Loxit", filename: data.Loxit.childImageSharp.fixed },
  ]

  const businessPartners = [
    { name: "Dell", filename: data.Dell.childImageSharp.fixed },
    { name: "HP", filename: data.HewlettPackard.childImageSharp.fixed },
    { name: "Lenovo", filename: data.Lenovo.childImageSharp.fixed },
    { name: "Acer", filename: data.Acer.childImageSharp.fixed },
    { name: "Asus", filename: data.Asus.childImageSharp.fixed },
    { name: "Fujitsu", filename: data.Fujitsu.childImageSharp.fixed },
    { name: "Toshiba", filename: data.Toshiba.childImageSharp.fixed },
    { name: "Microsoft", filename: data.Microsoft.childImageSharp.fixed },
    { name: "Samsung", filename: data.Samsung.childImageSharp.fixed },
    { name: "Apple", filename: data.Apple2.childImageSharp.fixed },
    { name: "Panasonic", filename: data.Panasonic.childImageSharp.fixed },
    { name: "Sony", filename: data.Sony.childImageSharp.fixed },
    { name: "Adobe", filename: data.Adobe.childImageSharp.fixed },
    { name: "Intel", filename: data.Intel.childImageSharp.fixed },
    { name: "Symantec", filename: data.Symantec.childImageSharp.fixed },
    { name: "VMWare", filename: data.VMWare.childImageSharp.fixed },
    { name: "Sophos", filename: data.Sophos.childImageSharp.fixed },
    { name: "Watchguard", filename: data.Watchguard.childImageSharp.fixed },
    { name: "DLink", filename: data.DLink.childImageSharp.fixed },
    { name: "Kaspersky", filename: data.Kaspersky.childImageSharp.fixed },
    { name: "Seagate", filename: data.Seagate.childImageSharp.fixed },
    {
      name: "Western Digital",
      filename: data.WesternDigital.childImageSharp.fixed,
    },
    { name: "TP-Link", filename: data.TPLink.childImageSharp.fixed },
  ]

  const networkPartners = [
    { name: "Aruba", filename: data.Aruba.childImageSharp.fixed },
    { name: "Cisco", filename: data.Cisco.childImageSharp.fixed },
    { name: "D-Link", filename: data.DLink.childImageSharp.fixed },
    {
      name: "HP Enterprise",
      filename: data.HP_enterprise.childImageSharp.fixed,
    },
    { name: "Netgear", filename: data.Netgear.childImageSharp.fixed },
    { name: "TP-Link", filename: data.TPLink.childImageSharp.fixed },
    { name: "Ubiquiti", filename: data.Ubiquiti.childImageSharp.fixed },
  ]

  const educationAudiovisualPartners = [
    {
      name: "SMART Promethean",
      filename: data.Promethean.childImageSharp.fixed,
    },
    { name: "Clevertouch", filename: data.Clevertouch.childImageSharp.fixed },
    { name: "C-Touch", filename: data.CTouch.childImageSharp.fixed },
    { name: "BenQ", filename: data.BenQ.childImageSharp.fixed },
    { name: "Epson", filename: data.Epson.childImageSharp.fixed },
    { name: "ViewSonic", filename: data.ViewSonic.childImageSharp.fixed },
    { name: "Sharp", filename: data.Sharp.childImageSharp.fixed },
    { name: "Iiyama", filename: data.Iiyama.childImageSharp.fixed },
    { name: "NEC", filename: data.NEC.childImageSharp.fixed },
    { name: "Sony", filename: data.Sony.childImageSharp.fixed },
    { name: "LG", filename: data.LG.childImageSharp.fixed },
    { name: "Philips", filename: data.Philips.childImageSharp.fixed },
    { name: "Casio", filename: data.Casio.childImageSharp.fixed },
    { name: "Canon", filename: data.Canon.childImageSharp.fixed },
    { name: "BTech", filename: data.BTech.childImageSharp.fixed },
  ]

  const partners =
    props.type === "education"
      ? educationPartners
      : props.type === "business"
      ? businessPartners
      : props.type === "networks"
      ? networkPartners
      : props.type === "educationAudiovisual"
      ? educationAudiovisualPartners
      : [{ name: "no partners set" }]

  function Partner(props) {
    return (
      <div className="client-box box-view-boxed-logo">
        <div className="client">
          <div className="client-logo-tooltip" data-tooltip={props.name}>
            {props.children}
          </div>
        </div>
      </div>
    )
  }

  return (
    <PartnersCarousel>
      <Container>
        <Row>
          <Col>
            <h5>{props.title}</h5>
            <p>{props.description}</p>
          </Col>
        </Row>
        <Row>
          <Col className="text-center">
            <Carousel>
              <Slider
                className="row slick_slider ttm-boxes-spacing-30px"
                {...slick_slider}
                slidesToShow={6}
              >
                {partners.map((partner, index) => (
                  <Partner name={partner.name} key={index}>
                    {partner.filename ? (
                      <Img
                        fixed={partner.filename}
                        className="img-fluid"
                        alt={partner.name + " logo"}
                      />
                    ) : (
                      <img
                        className="img-fluid"
                        src="https://via.placeholder.com/94X47/444444.png"
                        alt="placeholder"
                      />
                    )}
                  </Partner>
                ))}
              </Slider>
            </Carousel>
          </Col>
        </Row>
      </Container>
    </PartnersCarousel>
  )
}

const Carousel = styled.div`
  .slick-prev:before,
  .slick-next:before {
    color: #0e2b89;
  }
`

const PartnersCarousel = styled.section`
  h5,
  p {
    text-align: center;
  }
  .client-box {
    margin-bottom: 20px;
    padding: 15px 12px 30px;
  }
  .client-logo-tooltip {
    position: relative;
  }
  .client-box {
    &.box-view-boxed-logo {
      padding: 0;
      margin-top: 30px;
      margin-bottom: 30px;
      position: relative;
      display: block;
      .client-logo-tooltip {
        margin-right: 13px;
        margin-left: 13px;
        padding: 18px 12px;
        display: table-cell;
        text-align: center;
        align-items: center;
        vertical-align: middle;
      }
      .client {
        width: 100%;
        display: table;
        &:hover img {
          filter: grayscale(1);
        }
        img {
          margin: 0 auto;
        }
      }
    }
  }
`

export default PartnerCarousel
